import BulkDetails from './BulkDetails';

export default BulkDetails;
